import { z } from 'zod';
import { idArray } from './shared.schema';

export const ticketReconciliationReportFormatSchema = z.enum(['csv', 'pdf']);

export const ticketReconciliationSchema = z
	.object({
		reportStartDate: z.iso.date().optional(),
		reportEndDate: z.iso.date().optional(),
		areaIds: idArray.optional(),
		branchIds: idArray.optional(),
		districtIds: idArray.optional(),
		facilityIds: z.array(z.string()).optional(),
		format: ticketReconciliationReportFormatSchema.default('csv'),
		facilityNumber: z.union([z.string(), z.number()]).optional(),
	})
	.superRefine((value, ctx) => {
		if (!value.reportStartDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['reportStartDate'],
				message: 'reportStartDate required',
			});
		}

		if (value.reportStartDate && value.reportEndDate && value.reportEndDate < value.reportStartDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['reportEndDate'],
				message: 'reportEndDate must not be before reportStartDate',
			});
		}
	});

export type TicketReconciliationParameters = z.infer<typeof ticketReconciliationSchema>;
export type TicketReconciliationReportFormat = z.infer<typeof ticketReconciliationReportFormatSchema>;
